// extracted by mini-css-extract-plugin
var _1 = "bXJC3";
export { _1 as "container" }
